import { render, staticRenderFns } from "./onebox-directuploadfiles.vue?vue&type=template&id=81b18214&scoped=true&"
import script from "./onebox-directuploadfiles.vue?vue&type=script&lang=js&"
export * from "./onebox-directuploadfiles.vue?vue&type=script&lang=js&"
import style0 from "./onebox-directuploadfiles.vue?vue&type=style&index=0&id=81b18214&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b18214",
  null
  
)

export default component.exports